
import type {
  ParamTypeDefinition
} from '@uirouter/angular';

export class RouterParamSerializers {

  public static getSerializers(): Record<string, ParamTypeDefinition> {
    return {
      stringUpperCase: {
        encode: RouterParamSerializers.serializeStringUpperCase,
        decode: RouterParamSerializers.serializeStringUpperCase,
        is: (val: string): boolean => val === undefined || (typeof val === 'string' && val.toUpperCase() === val),
        equals: (a: string, b: string): boolean => a === b
      },
      stringLowerCase: {
        encode: RouterParamSerializers.serializeStringLowerCase,
        decode: RouterParamSerializers.serializeStringLowerCase,
        is: (val: string): boolean => val === undefined || (typeof val === 'string' && val.toLowerCase() === val),
        equals: (a: string, b: string): boolean => a === b
      },
      stringEncoded: {
        encode: RouterParamSerializers.serializeStringEncoded,
        decode: RouterParamSerializers.serializeStringDecoded,
        is: (val: string): boolean => val === undefined ||
                                  (
                                    typeof val === 'string' &&
                                    val === RouterParamSerializers.serializeStringEncoded(decodeURIComponent(val))
                                  ),
        equals: (a: string, b: string): boolean => a === b
      },

      number: {
        encode: RouterParamSerializers.numToString,
        decode: RouterParamSerializers.serializeNumber,
        is: (val: unknown): boolean => val === undefined || RouterParamSerializers.serializeNumber(val.toString()) === val,
        equals: (a: unknown, b: unknown): boolean => a === b
      },

      boolean: {
        encode: (val: unknown): string => val ? 'true' : 'false',
        decode: (val: unknown): boolean => val === true ? true : val === 'true',
        equals: (a: unknown, b: unknown): boolean => a === b,
        is: (val: number | boolean): boolean => [true, false, 0, 1].indexOf(val) >= 0,
        pattern: /bool|true|0|1/
      }
    };
  }

  private static serializeString(parameter: string, toCase: 'lower' | 'upper'): string {
    let param = parameter !== undefined && parameter !== null ? decodeURIComponent(parameter) : undefined;
    if (param !== undefined && param !== null) {
      if (toCase === 'lower') {
        param = param.toLowerCase();
      }
      if (toCase === 'upper') {
        param = param.toUpperCase();
      }
    }
    return param;
  }

  private static serializeStringUpperCase(parameter: string): string {
    return RouterParamSerializers.serializeString(parameter, 'upper');
  }

  private static serializeStringLowerCase(parameter: string): string {
    return RouterParamSerializers.serializeString(parameter, 'lower');
  }

  private static numToString(parameter: unknown): string { // encode number(float) to string
    return parameter !== null && parameter !== undefined ? parameter.toString() : parameter as string;
  }

  private static serializeNumber(parameter: string): number { // decode string to float
    return typeof parameter === 'string' && parameter !== '' ? Number(parameter) : undefined;
  }

  private static serializeStringEncoded(parameter: string): string {
    return encodeURIComponent(parameter)
      .replace(/%3A/gi, ':')
      .replace(/%24/gi, '$')
      .replace(/%2C/gi, ',')
      .replace(/%3B/gi, ';')
      .replace(/%2B/gi, '+')
      .replace(/%3D/gi, '=')
      .replace(/%3F/gi, '?')
      .replace(/%40/gi, '@')
      .replace(/%2F/gi, '/');
  }

  private static serializeStringDecoded(parameter: string): string {
    return decodeURIComponent(parameter);
  }
}
